import { Component, Input, OnChanges } from '@angular/core';
import { IInstalmentPlanInformation } from '@dch/billing-business-logic';
import { TranslationService } from '@dch/ng-common';
import { FormatPositiveAmountService } from './../services/format-positive-amount.service';

@Component({
  selector: 'my-bill-instalment-plan-progress-bar',
  templateUrl: './my-bill-instalment-plan-progress-bar.component.html',
  standalone: false,
})
export class MyBillInstalmentPlanProgressBarComponent implements OnChanges {
  @Input() instalmentPlanInformation: IInstalmentPlanInformation;

  progressBarContent = {
    minValue: 0,
    maxValue: 0,
    currentValue: 0,
    usageDataAlreadyUsed: '',
    usageDataRemaining: '',
  };
  amountToPay: string;

  constructor(
    private translationService: TranslationService,
    private formatPositiveAmountService: FormatPositiveAmountService
  ) {}

  ngOnChanges(): void {
    if (
      this.instalmentPlanInformation.sliceDetails?.length > 0 &&
      this.instalmentPlanInformation.paidAmount &&
      this.instalmentPlanInformation.totalAmount
    ) {
      this.setProgressBarContent();
    }
  }

  private setProgressBarContent() {
    this.progressBarContent.maxValue =
      this.instalmentPlanInformation.sliceDetails.length;

    this.progressBarContent.currentValue =
      this.instalmentPlanInformation.sliceDetails.filter(
        (sliceDetail) => sliceDetail.status === 'PAID'
      ).length;

    this.progressBarContent.usageDataAlreadyUsed =
      this.formatPositiveAmountService.getFormattedPositiveAmountWithCurrencyAndDecimal(
        this.instalmentPlanInformation.paidAmount
      ) +
      ' ' +
      this.translationService.getTranslatedValueFor('bills.instalment.paid');

    this.progressBarContent.usageDataRemaining =
      ' ' +
      this.translationService.getTranslatedValueFor('bills.instalment.outOf') +
      ' ' +
      this.formatPositiveAmountService.getFormattedPositiveAmountWithCurrencyAndDecimal(
        this.instalmentPlanInformation.totalAmount
      );
    this.amountToPay = this.instalmentPlanInformation?.amount ?? '0';
  }
}
